import { render, staticRenderFns } from "./ProspectCreate.vue?vue&type=template&id=e74cbac8"
import script from "./ProspectCreate.vue?vue&type=script&lang=ts"
export * from "./ProspectCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports